import CreateLogger from './create-logger.js';
var log = CreateLogger('emav');
var createLogger = log.createLogger;
export default log;
export {
    createLogger
};